"use client";

import React, { useEffect } from "react";
import { useCookies } from "react-cookie";
import { useCookieFirst } from '@cookiefirst/cookiefirst-react';
const consentSet = (setCookie, removeCookie) => {
	if (CookieFirst.consent?.performance) {
		_paq.push(["rememberConsentGiven"]);
		setCookie("consentGiven", "1");
	} else {
		_paq.push(["forgetCookieConsentGiven"]);
		removeCookie("consentGiven");
	}
};
const trackPage = () => {
	setTimeout(() => {
		_paq.push(["requireConsent"]);
		_paq.push(["setCustomUrl", window.location.pathname]);
		_paq.push(["setDocumentTitle", document.title]);
		_paq.push(["trackPageView"]);
	}, 10);
};
const checkHash = (context) => {
	if (window.location.hash === "#cookie-preferences") {
		console.log("context", context);
		context.openPanel();
		history.replaceState(null, "", " ");
	}
};
const CookieFirstHandler = ({ location }) => {
	
	const [inited, setInited] = React.useState(false);
	const [_cookies, setCookie, removeCookie] = useCookies();
  const context = useCookieFirst();

	
	useEffect(() => {
		let waitForTrackerCount = 0;
		if (!inited) {
			function matomoWaitForTracker() {
				if (typeof _paq === "undefined" || typeof CookieFirst === "undefined") {
					if (waitForTrackerCount < 40) {
						setTimeout(matomoWaitForTracker, 250);
						waitForTrackerCount++;
						return;
					}
				} else {
					window.addEventListener("cf_consent", function () {
						consentSet(setCookie, removeCookie);
						if (CookieFirst.consent?.performance) {
							trackPage();
						}
					});
					consentSet(setCookie, removeCookie);
				}
			}
			document.addEventListener("click", () => checkHash(context));
			setInited(true);
			checkHash(context);
			matomoWaitForTracker();
		}
	}, [inited, context, removeCookie, setCookie]);
	useEffect(() => {
		if (typeof _paq === "undefined") {
			return;
		}
		// require user tracking consent before processing data
		setTimeout(() => {
			_paq.push(["requireConsent"]);
			_paq.push(["setCustomUrl", location.pathname]);
			_paq.push(["setDocumentTitle", document.title]);
			_paq.push(["trackPageView"]);
		}, 10);
	}, [location]);
	return <></>;
};

export default CookieFirstHandler;
